export class ForgotPassword {
  Email: string;

  constructor() {
    this.Email = null;
  }
}
